import { getApprovalGroups } from '@lib/api'
import { approvalGroupsKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const useApprovalGroups = () => {
  return useQuery(approvalGroupsKeys.all, () => getApprovalGroups())
}
